import React from 'react';
import { renderNodeRule, StructuredText } from 'react-datocms';
import ImageWrapper from '../../Global/Image/ImageWrapper';
import Accordion from '../../Blocks/Accordion/Accordion';
import EmbedIframe from '../../Blocks/EmbedIframe/EmbedIframe';
import Table from '../Table/Table';
import Cta from '../../Global/Cta/Cta';
import BlockMembers from '../BlockMembers/BlockMembers';
import BlockHeadlineWithIcon from '../BlockHeadlineWithIcon/BlockHeadlineWithIcon';
import BlockEmbed from '../BlockEmbed/BlockEmbed';
import BlockVacancies from '../BlockVacancies/BlockVacancies';
import FileAssets from '../FileAssets/FileAssets';
import ManualVideo from '../ManualVideo/ManualVideo';
import SingleForm from '../SingleForm/SingleForm';
import { cleanContent } from '../../../utils/dato.utils';
import Link from '../../Global/Link/Link';
import BlockImageHyperlink from '../BlockImageHyperlink/BlockImageHyperlink';
import { isLink } from 'datocms-structured-text-utils';
import SocialMediaLink from '../SocialMediaLink/SocialMediaLink';

const StructuredTextDefault = ({ content }) => {
  if (!content || !content?.value) return null;
  const cleanedContent = cleanContent(content);

  return (
    <StructuredText
      data={cleanedContent}
      renderBlock={({ record }) => {
        switch (record.__typename) {
          case 'DatoCmsEmbedIframe':
            return <EmbedIframe content={record} key={record.id} />;
          case 'DatoCmsTableBlock':
            return <Table content={record} key={record.id} />;
          case 'DatoCmsAcordion':
            return <Accordion items={record.items} key={record.id} />;
          case 'DatoCmsCta':
            return (
              <div key={record.id} className="structured-cta">
                <Cta cta={record} />
              </div>
            );
          case 'DatoCmsMembersBlock':
            return <BlockMembers key={record.id} block={record} />;
          case 'DatoCmsImage':
            return (
              <div key={record.id}>
                <ImageWrapper image={record.image} />
              </div>
            );
          case 'DatoCmsHeadlineWithIcon':
            return <BlockHeadlineWithIcon key={record.id} block={record} />;
          case 'DatoCmsEmbed':
            return <BlockEmbed key={record.id} block={record} />;

          case 'DatoCmsVacancyBlock':
            return <BlockVacancies key={record.id} block={record} />;

          case 'DatoCmsFile':
            return <FileAssets key={record.id} block={record} />;

          case 'DatoCmsVideo':
            return <ManualVideo key={record.id} block={record} />;

          case 'DatoCmsSingleForm':
            return <SingleForm key={record.id} block={record} />;

          case 'DatoCmsTable':
            return <Table key={record.id} block={record} />;

          case 'DatoCmsImageHyperlink':
            return <BlockImageHyperlink key={record.id} block={record} />;

          case 'DatoCmsSocialMediaLink':
            return <SocialMediaLink key={record.id} block={record} />;

          default:
            return null;
        }
      }}
      renderLinkToRecord={({ record, children }) => {
        return <Link to={record}>{children}</Link>;
      }}
      customNodeRules={[
        renderNodeRule(isLink, ({ adapter: { renderNode }, node, children, key }) => {
          if (node.url.startsWith('#')) {
            return renderNode('a', { href: node.url, key }, children);
          }

          return renderNode('a', { href: node.url, target: '_blank', rel: 'noopener noreferrer', key }, children);
        }),
      ]}
    />
  );
};

export default StructuredTextDefault;
